export const DEFAULT_COLORS = {
  background: "#F5F5F5",
  home_card: "#F6F6F6",
  home_button: "#555555",
  home_button_text: "#fff",
  home_text: "#555555",
  home_info_text: "#AAAAAA",
  survey_card: "#F6F6F6",
  nav_button_circle: "#FFD700",
  nav_button_arrow: "#FFFFFF",
  scroll_indicator: "#F57B51",
  help_text: "#A6A6A6",
  input_background: "#FFFFFF",
  input_placeholder: "#C6C6C6",
  input_text: "#000000",
  question_text: "#3B6978",
  option_text: "#204051",
  table_text: "#000000",
  selected_option: "#639A67",
  option_card: "#FFFFFF",
  option_card_outline: "#E7E7E7",
  invalid: "#D7385E",
  valid: "#639A67",
  correct: "#71BD31",
  incorrect: "#EB595A",
  unfilled_percentage_circle: "#EEEEEE",
  media_button_bg: "#000000",
  table_background: "rgba(0, 0, 0, 0.2)",
  table_header: "rgba(0, 0, 0, 0.2)",

  themeGrey: "#C1C1C1",
  themeDarkGrey: "#676767",
  themeLightGrey: "#707070",
  themeLightestGrey: "#E0E0E0",
  themeWhite: "#FFFFFF",
  themeLightWhite: "#e4e4e4",
  themeBlue: "#002D72",
  themePink: "#E92662",
  themeLightBlue: "#1492E6",
  themeYellow: "#FFE500",
  themeBlack: "#000000",
  themeLightBlack: "#494A4B",
  themeRed: "#F8E2E3",
  themeLightRed: "#cf2e2e",
  themeMaroon: "#E92662",

  selected_option_background: "#002D72",

  nav_forward_button: "#002D72",
  nav_previous_button: "#002D72",
  nav_forward_button_disabled: "#1f3a54",
  nav_background: "#002D72",
  nav_button_background: "transparent",

  open_ended_text: "#002D72",
  open_ended_label: "#000000",
  open_ended_borders: "#002D72",
  open_ended_background: "#ffffff",
  open_ended_borders_inactive: "#676767",
  responsible_user_list_background: "#e0e0e0",

  score_text: "#ffffff",
  score_border: "#e4e4e4",
  score_text_selected: "#002D72",
  score_description: "#ffffff",
  score_description_line: "#ffffff",
  score_background_selected: "#ffffff",
  score_background: "rgba(0, 0, 0, 0.5)",
  description_heading_text: "#ffffff",
  description_text: "#ffffff",

  progress_bar_fg: "#FFE500",
  progress_bar_bg: "#c1C1C1",
  progress_bar_text: "#002D72",

  image_background: "#002D72",
  image_background_selected: "#002D72",
  image_text: "#FFE500",
  image_text_selected: "#FFE500",
  image_unselected: "",
  image_selected: "",

  happy_emoji_checked_color: "#0DBA12",
  neutral_emoji_checked_color: "#F7B239",
  sad_emoji_checked_color: "#D33F45",
};
